const profile = {
  name: 'Manit Dankhara',
  title: 'Computer Science Student | Software Engineering Intern Candidate',
  summary:
    'Computer Science student at the University of Texas at Arlington with hands-on experience in backend development, full-stack applications, REST APIs, databases, and AI-powered systems. Skilled in Python, Java, SQL, JavaScript, TypeScript, React, FastAPI, Flask, Django, MySQL, PostgreSQL, Docker, Kubernetes, Git, software testing, debugging, and object-oriented programming.',
  location: 'Fort Worth, TX',
  availability: 'Seeking software engineering, backend, full-stack, and AI engineering internships',
  phone: '(682) 509-1460',
  email: 'manitdankhara007@gmail.com',
  avatarUrl: `${process.env.PUBLIC_URL}/PHOTO.jpeg`,
  githubUsername: 'manit0700',
  githubUrl: 'https://github.com/manit0700',
  linkedInUrl: 'https://www.linkedin.com/in/manit-dankhara-528091262',
  education: [
    {
      school: 'University of Texas at Arlington',
      degree: 'Bachelor of Science, Computer Science',
      year: 'Dec 2026',
      location: 'Arlington, TX',
      coursework:
        'Data Structures and Algorithms, Database Systems, Web Development, Software Engineering, Object-Oriented Programming, Computer Organization',
    },
  ],
  experience: [
    {
      org: 'University of Texas at Arlington',
      role: 'Administrative Assistant',
      dates: 'May 2026 - Present',
      bullets: [
        'Assist in writing and testing Python and Java scripts to validate hardware inventory logs before indexing records into database systems and tracking tools.',
        'Maintain university asset tracking records across MySQL database tables, supporting accurate reporting, documentation, inventory visibility, and operational workflows.',
        'Collaborate with team members to resolve asset logistics issues, update documentation logs, verify records, and improve campus operations workflows.',
      ],
    },
    {
      org: 'University of Texas at Arlington',
      role: 'Resident Assistant',
      dates: 'Aug 2025 - May 2026',
      bullets: [
        'Supported an on-campus community of 30+ residents while collaborating with housing staff, campus resources, safety teams, and university departments.',
        'Planned student engagement activities while maintaining documentation, communication records, incident reports, and safety-related logs.',
        'Strengthened leadership, conflict resolution, communication, problem-solving, time management, and workflow coordination skills in a deadline-driven environment.',
      ],
    },
  ],
  projects: [
    {
      title: 'EvolveAgent AI - Full-Stack Multi-Agent AI Workspace',
      date: 'May 2026 - Present',
      tags: ['FastAPI', 'React', 'TypeScript', 'OpenAI', 'Multi-Agent Systems', 'n8n'],
      repo: 'https://github.com/manit0700/evolveagent-ai',
      image: `${process.env.PUBLIC_URL}/evolveagent_ai_project.png`,
      summary:
        'Full-stack AI workspace for task routing, document analysis, workflow execution, workspace memory, and project-based AI assistance.',
      impact: ['57 backend tests', 'Frontend build passed', 'Approval-gated automation'],
      bullets: [
        'Built a multi-agent AI workspace using FastAPI, React, TypeScript, OpenAI, and n8n-style workflow orchestration.',
        'Implemented multi-LLM consensus, Judge Agent scoring, per-agent evaluation, workflow analytics, custom agent creation, and goal planning.',
        'Added prompt-injection checks, secret scanning, safe file editing, allowlisted command execution, and approval-gated automation.',
        'Validated reliability with 57 backend tests and a successful frontend build.',
      ],
    },
    {
      title: 'Pharmacy Inventory Recognition Using Computer Vision',
      date: 'Apr 2026',
      tags: ['Python', 'TensorFlow', 'Computer Vision', 'MobileNetV2'],
      repo: 'https://github.com/manit0700/pharmacy-inventory-recognition',
      image: `${process.env.PUBLIC_URL}/pharmacy_inventory_recognition.png`,
      summary:
        'Computer vision system that classifies medication bottle images and turns predictions into inventory decisions.',
      impact: ['13,955 images', '20 NDC classes', '3 inventory statuses'],
      bullets: [
        'Built a medication image classification workflow using MobileNetV2 transfer learning and TensorFlow/Keras.',
        'Used a real-world University of Michigan Deep Blue medication bottle dataset with 13,955 images and 20 NDC classes.',
        'Connected model predictions to inventory logic for OK, REORDER, and EXPIRY RISK status reporting.',
        'Prepared a full project package with code, notebook, proposal, presentation, and dataset citation.',
      ],
    },
    {
      title: 'MarketVision AI Hub - Database Integration Platform',
      date: 'Jan 2026',
      tags: ['Java', 'Python', 'FastAPI', 'MySQL', 'REST APIs', 'Dashboards'],
      repo: '',
      image: `${process.env.PUBLIC_URL}/ai_stock_project.png`,
      summary:
        'Responsive web application and backend data platform for analytical dashboards, structured data ingestion, and REST API integrations.',
      impact: ['40% sync delay reduction', 'MySQL schemas', 'Async connectors'],
      bullets: [
        'Developed a responsive web application using Java, Python, FastAPI, and MySQL for dashboards, structured data ingestion, API integrations, and backend data processing.',
        'Designed relational MySQL schemas and asynchronous database connectors to support multi-source workflows and reduce API data sync delays by 40%.',
        'Applied object-oriented programming, testing, debugging, and modular backend design practices to improve reliability across simulated production workflows.',
      ],
    },
    {
      title: 'Fusion AI Multi-Source Assistant - API Web Services Engine',
      date: 'Jan 2026',
      tags: ['Python', 'Flask', 'REST APIs', 'Docker', 'Databases', 'Web Services'],
      repo: 'https://github.com/manit0700/Fusion-ai-',
      image: `${process.env.PUBLIC_URL}/fusion_ai_project.png`,
      summary:
        'Modular backend application that connects external cloud endpoints with internal application services across multi-source data workflows.',
      impact: ['25% precision gain', 'Reusable service layers', 'Dockerized app'],
      bullets: [
        'Engineered a modular backend application using Python, Flask, REST APIs, Docker, and database integrations.',
        'Created reusable service layers for request handling, data formatting, API validation, error handling, and backend communication.',
        'Improved multi-source query precision and response alignment by 25%.',
      ],
    },
    {
      title: 'Wikipedia-RAG-Studio - Local Document Retrieval System',
      date: 'Mar 2025',
      tags: ['TypeScript', 'Java', 'RAG', 'Retrieval Evaluation', 'Text Processing'],
      repo: '',
      image: `${process.env.PUBLIC_URL}/wiki_rag_studio.png`,
      summary:
        'Local retrieval and indexing system for raw text repositories, citation tracking, retrieval quality evaluation, and benchmarking.',
      impact: ['96.0% benchmark', 'Citation tracking', 'Local indexing'],
      bullets: [
        'Built a local retrieval and indexing system using TypeScript, Java-based object-oriented components, structured file processing, and modular text preprocessing pipelines.',
        'Developed workflows to ingest raw text repositories, evaluate retrieval quality, benchmark citation tracking, and measure retrieval accuracy.',
      ],
    },
  ],
  skills: {
    languages: ['Python', 'Java', 'SQL', 'JavaScript', 'TypeScript', 'C++', 'C', 'HTML5', 'CSS3'],
    frameworks: [
      'React',
      'FastAPI',
      'Flask',
      'Django',
      'OpenAI API',
      'REST APIs',
      'JSON',
      'Web Services',
    ],
    databasesCloud: [
      'MySQL',
      'PostgreSQL',
      'SQL Server',
      'SQLite',
      'Relational Database Design',
      'Query Optimization',
      'Azure',
      'AWS APIs',
    ],
    tools: ['Git', 'GitHub', 'Docker', 'Kubernetes', 'Linux', 'Postman', 'VS Code'],
    aiAutomation: [
      'LLMs',
      'RAG',
      'Multi-Agent Systems',
      'Prompt Engineering',
      'Workflow Automation',
      'AI Evaluation',
      'n8n',
    ],
    professional: [
      'Object-Oriented Programming',
      'Data Structures',
      'Algorithms',
      'API Design',
      'Database Design',
      'Testing',
      'Debugging',
      'Agile/Scrum',
    ],
  },
  activities: [
    {
      org: 'University of Texas at Arlington',
      dates: 'Aug 2023 - May 2024',
      bullets: [
        'Member, UT Arlington Computer Science Club',
        'Volunteer Tutor: Python and C++',
      ],
    },
  ],
};

export default profile;
